import React from 'react';
// Import contexts
import { useFormContext } from 'react-hook-form';
// Import components
import Input from 'components/shared/FormElements/Input/Input';
import Textarea from 'components/shared/FormElements/Input/textarea';

const Address = () => {
  const { register } = useFormContext(); // Custom hook for handling validation (errors etc)

  const postcodeRegex =
    /^([Gg][Ii][Rr] 0[Aa]{2})|((([A-Za-z][0-9]{1,2})|(([A-Za-z][A-Ha-hJ-Yj-y][0-9]{1,2})|(([A-Za-z][0-9][A-Za-z])|([A-Za-z][A-Ha-hJ-Yj-y][0-9]?[A-Za-z])))) [0-9][A-Za-z]{2})$/;

  return (
    <fieldset className="wmcads-fe-fieldset">
      {/* Address */}
      <Textarea
        className="wmcads-col-1 wmcads-col-lg-3-4"
        name="Address"
        label="Event location (Address)"
        fieldValidation={register({
          required: 'Enter a address',
          pattern: {
            message: 'Enter a address.',
          },
        })}
      />

      {/* Postcode */}
      <Input
        name="AddressPostcode"
        label="Postcode"
        className="wmcads-col-1-2 wmcads-col-sm-1-4"
        autocomplete="postal-code"
        fieldValidation={register({
          required: 'Enter a postcode',
          pattern: {
            value: postcodeRegex,
            message: 'Enter a postcode in the correct format, for example B19 3SD',
          },
        })}
      />
    </fieldset>
  );
};

export default Address;
